var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',_vm._b({ref:"modal",attrs:{"footer":_vm.footer,"visible":_vm.isVisible,"dialogClass":"transparent","wrapClassName":"custom-modal","dialogStyle":{
      padding:0,
      backgroundColor: 'transparent',
    },"bodyStyle":{
      padding:0,
      backgroundColor: 'transparent',
      marginBottom: 100
    }},on:{"cancel":function($event){return _vm.$emit('cancel', $event)}},scopedSlots:_vm._u([(!_vm.showCancel)?{key:"closeIcon",fn:function(){return undefined},proxy:true}:null],null,true)},'a-modal',_vm.$attrs,false),[_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }